import Script, { type ScriptProps } from 'next/script';
import React, { cache } from 'react';

import type { TCMSContent } from '@/types/cms';

const addLazyLoadingToImages = cache((html: string): string => {
  return html
    .replace(/(<img[^>]*?)\s+loading="[^"]*"([^>]*>)/gi, '$1$2')
    .replace(/<img([^>]*>)/gi, '<img loading="lazy"$1');
});

const CMSComponent = ({ data, scriptProps }: { data: TCMSContent; scriptProps?: ScriptProps }) => {
  const processedContent = data.content ? addLazyLoadingToImages(data.content) : '';

  return (
    <>
      {processedContent && <div dangerouslySetInnerHTML={{ __html: processedContent }} />}
      {data.scriptUrl && <Script defer src={data.scriptUrl} {...scriptProps} strategy="lazyOnload" />}
    </>
  );
};

export default CMSComponent;
